export default __webpack_public_path__ + "static/media/AML.14557ecb.png";